import Mock from "mockjs";
import banner from "./banner";

Mock.mock("/api/banner/list", "get", () => {
  return {
    code: 200,
    message: "成功",
    data: banner,
  };
});

Mock.mock("/api/v1/game/list-select", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          id: 1157,
          name: "绝世萌仙",
        },
        {
          id: 1156,
          name: "测试",
        },
      ],
    },
    debug: {
      redis: ["get ACCESS_TOKEN_0d2137a3bdf5437b50ce"],
      mysql: [
        'select * from `sdk_users` where `cp_uid` = "9e5598a73a8deadd6ede" limit 1',
        "select * from `box_game_exts`",
      ],
    },
  };
});

Mock.mock("/api/v1/user/do-poll", "post", () => {
  return {
    code: 1013,
    msg: "票数不足！",
    data: [],
    debug: {
      redis: [
        "get ACCESS_TOKEN_fa76354f7127c3aa316b",
        "SETNX access_lock_doPoll219 0.18755800 1678939115",
        "EXPIRE access_lock_doPoll219 3",
        "DEL access_lock_doPoll219",
      ],
      mysql: [
        'select * from `sdk_users` where `cp_uid` = "9e5598a73a8deadd6ede" limit 1',
        "select * from `box_anchors` where `box_anchors`.`id` = 1 limit 1",
        "select * from `box_user_exts` where `user_id` = 219 limit 1",
      ],
    },
  };
});

Mock.mock("/api/v1/user/role-list-select", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          id: "2124218749682076",
          name: "欢神527服 | S527.大瑗飞",
        },
      ],
    },
    debug: {
      redis: ["get ACCESS_TOKEN_fa76354f7127c3aa316b"],
      mysql: [
        'select * from `sdk_users` where `cp_uid` = "9e5598a73a8deadd6ede" limit 1',
        "select `server_name`, `role_name`, `role_id`, `game_id`, `user_id` from `sdk_levels` where `game_id` = 1157 and `user_id` = 219",
      ],
    },
  };
});

Mock.mock("/api/v1/anchor/normal", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      anchor_poll: 0,
      list: [
        {
          id: 1,
          name: "测试卓宝",
          icon: "https://material.gameyiming.com/images/zzcq_28_28.png",
          room_id: 1025568,
          desc: "",
          title: "",
          video_title: "快来玩",
          video_desc: "哈哈",
          game_video:
            "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
          live_status: 2,
          live_status_str: "直播完成",
        },
        {
          id: 1,
          name: "测试卓宝",
          icon: "https://material.gameyiming.com/images/zzcq_28_28.png",
          room_id: 1025568,
          desc: "",
          title: "",
          video_title: "快来玩",
          video_desc: "哈哈",
          game_video:
            "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
          live_status: 2,
          live_status_str: "直播完成",
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/anchor/detail", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      poll: 0,
      anchor_detail: {
        name: "测试卓宝",
        icon: "https://material.gameyiming.com/images/zzcq_28_28.png",
        room_id: 1025568,
        desc: "",
        live_status: 3,
        live_status_str: "直播完成",
      },
      list: [
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
        {
          title: "快来玩",
          desc: "哈哈",
          url: "https://material.gameyiming.com/files/ebf5552ecaa97a363586f65784a11af7.mp4",
        },
      ],
      page: 1,
      per_page: 10,
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/anchor/anchor", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      anchor_name: "测试卓宝",
      anchor_icon: "https://material.gameyiming.com/images/zzcq_28_28.png",
      list: [
        {
          id: 1,
          title: "测试任务",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          start_time: "2023-03-03 00:00:00",
          end_time: "2023-03-04 00:00:00",
          status: 0,
          award_type: 1,
          award_content: "100",
          status_str: "去参与",
        },
        {
          id: 1,
          title: "测试任务",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          start_time: "2023-03-03 00:00:00",
          end_time: "2023-03-04 00:00:00",
          status: 0,
          award_type: 1,
          award_content: "100",
          status_str: "去参与",
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/anchor/task-detail", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      title: "测试任务",
      icon: "https://material.gameyiming.com/images/zzcq.png",
      award_type: 1,
      award_content: "100",
      start_time: "2023-03-03 00:00:00",
      end_time: "2023-03-04 00:00:00",
      desc: "dwefdwe",
    },
  };
});

Mock.mock("/api/v1/anchor/partake", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
  };
});

Mock.mock("/api/v1/anchor/my-income", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      month_income: "100",
      page: 1,
      per_page: "10",
      total_record: 1,
      list: [
        {
          id: 3,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 4,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 6,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 7,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 8,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 8,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 8,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
        {
          id: 8,
          title: "测试任务",
          created_at: "2023-03-21 03:54:37",
          value: 100,
        },
      ],
    },
  };
});

Mock.mock("/api/v1/anchor/withdrawal-index", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      amount: 2.4,
      payment: [
        {
          config: [
            {
              id: 55,
              amount: "200.00",
              desc: "海南奕鸣",
            },
          ],
          icon: "https://material.gameyiming.com/image/avatar/wechat_pay_logo.png",
          name: "微信",
          type: "wechat",
        },
        {
          config: [],
          icon: "https://material.gameyiming.com/image/avatar/alipay_logo.png",
          name: "支付宝",
          type: "alipay",
        },
      ],
      tips: "这个是提示",
    },
  };
});

Mock.mock("/api/v1/anchor/do-withdrawal", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
    debug: {
      redis: [
        "get ACCESS_TOKEN_82d22c2275b99ed77361",
        "SETNX access_lock_doWithdrawal219 0.74869400 1679390093",
        "EXPIRE access_lock_doWithdrawal219 3",
        "DEL access_lock_doWithdrawal219",
      ],
      mysql: [
        'select * from `sdk_users` where `cp_uid` = "9e5598a73a8deadd6ede" limit 1',
      ],
    },
  };
});

Mock.mock("/api/v1/user/center", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      id: 149,
      nickname: "18572821456",
      head_img: "",
      mobile: "18572821456",
      sex: 0,
      vip: 1,
      integral: 200,
      wechat_nickname: "",
      plat_coin: 0,
      ali_account: "童咏华",
      appid: "wxe4baa0da1437b2e4",
      universe_link: "https://dl.freegame4.com/jsmx.html/",
    },
  };
});

Mock.mock("/api/v1/user/modify-user-info", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
  };
});

Mock.mock("/api/v1/user/send-sms", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
  };
});

Mock.mock("/api/v1/user/update-mobile", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
  };
});

Mock.mock("/api/v1/user/plat-coin-list", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      plat_coin: 0,
      list: [
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
        {
          id: 5,
          name: "内部平台币申请:批量审核通过",
          created_at: "2023-02-17 07:22:36",
          value: -2,
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/user/bind-ali", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [],
  };
});

Mock.mock("/api/v1/vip/index", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      vip: 1,
      next_level: 1,
      growth: 60.00,
      all_vips: [
        {
          level: 1,
          growth: 1,
        },
        {
          level: 2,
          growth: 1,
        },
      ],
      privileges: [
        {
          id: 1,
          name: "1v1客服",
          icon: "https://material.gameyiming.com/images/jjdz_108_108.png",
          range: "等级为VIP1以上的vip专享",
          desc: "这是描述",
        },
      ],
      need_growth: 1,
      banner:
        "https://material.gameyiming.com/files/AUPKK[ZQ]KN_MQDU]71G9WL.png",
      rule: "",
      prop_msg: {
        msg_type: 2,
        title: "VIP1晋级福利",
        content: [
          "绝世萌仙满10元97.00折代金券asdfasdfsa发射点发射点发射点发",
          "绝世萌仙满10元97.00折代金券",
        ],
        button_content: "领取",
        request_api: "/api/v1/vip/draw",
      },
    },
  };
});

Mock.mock("/api/v1/vip/draw", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      code: 0,
      data: [],
      msg: "",
    },
  };
});

Mock.mock("/api/v1/user/my-game", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/coupon/normal", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙2",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
          list: [
            {
              id: 5,
              name: "满10元97折",
              is_limit: 1,
              sub_title: "满10元可用",
              type: 3,
              use_type: 2,
              value: "10",
              deduct: "97",
              limit_str: "仅绝世萌仙使用",
              end_time_str: "2023-03-16 00:00 过期",
            },
            {
              id: 4,
              name: "无门槛代金券",
              is_limit: 1,
              sub_title: "无门槛",
              type: 1,
              use_type: 2,
              value: "0",
              deduct: "10",
              limit_str: "仅绝世萌仙使用",
              end_time_str: "2023-03-15 00:00 过期",
            },
            {
              id: 2,
              name: "满3减2",
              is_limit: 2,
              sub_title: "满3元可用",
              type: 2,
              use_type: 2,
              value: "3",
              deduct: "2",
              limit_str: "仅绝世萌仙使用",
              end_time_str: "领取后2日内有效",
            },
            {
              id: 1,
              name: "满3减2",
              is_limit: 2,
              sub_title: "满3元可用",
              type: 2,
              use_type: 2,
              value: "3",
              deduct: "2",
              limit_str: "仅绝世萌仙使用",
              end_time_str: "领取后2日内有效",
            },
          ],
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/coupon/common", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
        {
          id: 6,
          name: "",
          is_limit: 1,
          sub_title: "无门槛",
          type: 1,
          use_type: 1,
          value: "10",
          deduct: "0",
          limit_str: "通用代金券",
          end_time_str: "2023-03-24 00:00 过期",
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/gift/center", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          ranking: 1,
          game_id: 1157,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
          normal: [],
          vip: [],
        },
        {
          ranking: 1,
          game_id: 1158,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
          normal: [
            {
              id: 6,
              name: "测试礼包",
              desc: "tttu",
              method: "用方法",
              total: 10,
              total_remain: 7,
              status: 2,
              status_str: "领取",
            },
          ],
          vip: [],
        },
        {
          ranking: 1,
          game_id: 1159,
          game_type: 2,
          game_name: "绝世萌仙",
          is_rpg: 1,
          order: 0,
          score: "9.0",
          cate: [
            {
              id: 2,
              name: "回合",
            },
            {
              id: 1,
              name: "传奇",
            },
          ],
          banner:
            "https://material.gameyiming.com/images/4e807597ca1869bbdd20edfe33f4876.jpg",
          open_service_type: 1,
          open_service_type_name: "动态开服",
          game_url:
            "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          is_download: 0,
          normal: [
            {
              id: 6,
              name: "测试礼包",
              desc: "tttu",
              method: "用方法",
              total: 10,
              total_remain: 7,
              status: 2,
              status_str: "领取",
            },
          ],
          vip: [],
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/game/guess", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: [
      {
        game_id: 1157,
        game_type: 2,
        game_name: "绝世萌仙",
        icon: "https://material.gameyiming.com/images/zzcq.png",
        game_url:
          "https://h5.gameyiming.com/h5sdkv3/#/?game_id=1157&vest_id=1138",
      },
      {
        game_id: 1156,
        game_type: 1,
        game_name: "测试",
        icon: "",
        game_url:
          "https://apk.gameyiming.com/package/1281-6768fd2f3ff3a88ff6ea9928889b11b0.apk",
      },
      {
        game_id: 1156,
        game_type: 1,
        game_name: "测试",
        icon: "",
        game_url:
          "https://apk.gameyiming.com/package/1281-6768fd2f3ff3a88ff6ea9928889b11b0.apk",
      },
      {
        game_id: 1156,
        game_type: 1,
        game_name: "测试",
        icon: "",
        game_url:
          "https://apk.gameyiming.com/package/1281-6768fd2f3ff3a88ff6ea9928889b11b0.apk",
      },
    ],
  };
});

Mock.mock("/api/v1/anchor/my-task", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      page: 1,
      per_page: "10",
      total_record: 1,
      list: [
        {
          id: 1,
          title: "任意单款游戏创角10人",
          icon: "",
          task_time: "2023-03-21 03:54:37-2023-03-28 03:54:37",
          status: 4,
          award_type: 1,
          award_content: "100",
          status_str: "已过期",
        },
      ],
    },
  };
});

Mock.mock("/api/v1/coupon/my", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
        {
          id: 2,
          name: "满3减2",
          is_limit: 2,
          sub_title: "满3元可用",
          type: 2,
          use_type: 2,
          value: "3",
          deduct: "2",
          limit_str: "仅绝世萌仙使用",
          end_time_str: "领取后2日内有效",
        },
      ],
      type: "1",
      page: 1,
      per_page: 10,
      total_record: 1,
      rule: "",
    },
  };
});

Mock.mock("/api/v1/gift/my", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          name: "测试礼包",
          code: "vip666",
          desc: "tttu",
          method: "用方法",
        },
        {
          name: "测试礼包",
          code: "vip666",
          desc: "tttu",
          method: "用方法",
        },
        {
          name: "测试礼包",
          code: "vip666",
          desc: "tttu",
          method: "用方法",
        },
        {
          name: "测试礼包",
          code: "vip666",
          desc: "tttu",
          method: "用方法",
        },
        {
          name: "测试礼包",
          code: "vip666",
          desc: "tttu",
          method: "用方法",
        },
      ],
      page: "1",
      per_page: "10",
      total_record: 1,
    },
  };
});

Mock.mock("/api/v1/task/my", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      new_list: [
        {
          id: 1,
          title: "心力物语任务",
          sub_title: "11",
          status: 1,
          status_str: "进行中",
          icon: "https://material.gameyiming.com/images/587bc7d26864c4dd00427e9080f19465.jpg",
        },
      ],
      center_list: [
        {
          id: 2,
          title: "签到3次",
          award_str: "积分",
          require_str: "去签到3次",
          time_str: "无限制",
          icon: "https://material.gameyiming.com/images/mxw_28_28.png",
          game_id: 0,
          status: 0,
          status_str: "去参与",
        },
        {
          id: 3,
          title: "绝世萌仙",
          award_str: "平台币、代金券",
          require_str: "",
          time_str: "",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          game_id: 1157,
          status: 0,
          status_str: "去参与",
        },
      ],
      host_list: [
        {
          id: 1,
          title: "112",
          sub_title: "12",
          status: 1,
          status_str: "进行中",
          image:
            "https://material.gameyiming.com/images/MAZHC)KSUG5))_SNPMB2L~3.png",
        },
      ],
    },
  };
});

Mock.mock("/api/v1/task/draw", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      code: 0,
      msg: "条件不满足",
      data: null,
    },
  };
});

Mock.mock("/api/v1/task/my-task-detail", "post", () => {
  return {
    code: 0,
    msg: "ok",
    data: {
      list: [
        {
          id: "5-4",
          title: "创角1天内玩2小时游戏",
          award_str: "asdfadf",
          require_str: "创角1天内玩2小时游戏",
          time_str: "1天内",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          game_id: 1157,
          status: 3,
          status_str: "已完成",
        },
        {
          id: "5-4",
          title: "创角1天内玩2小时游戏",
          award_str: "",
          require_str: "创角1天内玩2小时游戏",
          time_str: "1天内",
          icon: "https://material.gameyiming.com/images/zzcq.png",
          game_id: 1157,
          status: 2,
          status_str: "已完成",
        },
      ],
      game: {
        game_id: 1157,
        game_name: "绝世萌仙",
        icon: "https://material.gameyiming.com/images/zzcq.png",
      },
    },
  };
});
